/*
 * pupstyle.js — Lazy-Load von JS/CSS/iframes erst bei erster User-Interaktion.
 * Lokal gehostet (vorher: storeswlaescript.myshopify.com – Fremd-Store, entfernt).
 * FIX: urspruengliches `observer.disconnect()` entfernt — es gab keinen passenden
 * globalen `observer`, daher "Uncaught ReferenceError: observer is not defined".
 */
var script_loaded = false;

function loadJSscripts() {
  if (script_loaded) return;
  script_loaded = true;

  // iframes mit class="lazy" aktivieren
  document.querySelectorAll("iframe.lazy").forEach(function (el) {
    if (el.dataset.src != null) el.src = el.dataset.src;
  });

  // <script data-src> / <script type="text/lazyload"> aktivieren
  var scripts = document.getElementsByTagName("script");
  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].getAttribute("data-src") !== null) {
      scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
      delete scripts[i].dataset.src;
    }
    if (scripts[i].getAttribute("type") == "text/lazyload") {
      var s = document.createElement("script");
      for (var a = 0; a < scripts[i].attributes.length; a++) {
        s.setAttribute(scripts[i].attributes[a].name, scripts[i].attributes[a].value);
      }
      s.type = "text/javascript";
      s.innerHTML = scripts[i].innerHTML;
      scripts[i].parentNode.removeChild(scripts[i]);
      scripts[i].parentNode.insertBefore(s, scripts[i]);
    }
  }

  // <link data-href> aktivieren
  var links = document.getElementsByTagName("link");
  for (var j = 0; j < links.length; j++) {
    if (links[j].getAttribute("data-href") !== null) {
      links[j].setAttribute("href", links[j].getAttribute("data-href"));
      delete links[j].dataset.href;
    }
  }

  document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
}

["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"]
  .forEach(function (evt) {
    window.addEventListener(evt, loadJSscripts, { passive: true });
  });
